<template>
<div class="footer_lyout_b">
    <div class="footer_lyout defalut_content_width">
        <div class="footer_lyout_logo">
            <img  @click="clickLogo" :src="require('assets/images/general/header_logo.png')" alt="">
        </div>

        <div class="footer_lyout_content">
            <div class="footer_lyout_content_menu">
                <template v-if="!$utils.isArrayEmpty(list)">
                    <template v-for="(item,index) in list">
                        <div v-if="!$utils.isArrayEmpty(item.children)" :key="index" class="footer_lyout_content_menu_item">
                            <div v-if="index!=0" class="footer_lyout_content_line defalut_boder_right_line"></div>
                            <div class="menu_content" :class="{menu_content2:index!=0}">
                                <div @click="clickMenu(item)" :class="{cursorPointer:$utils.isNoNullAll(item.routeUrl)}" class="menu_content_name">{{item.name}}</div>
                                <div class="menu_content_list">
                                    <span @click="clickMenu(item2)" v-for="(item2,index2) in item.children" :key="index+'_'+index2" class="menu_content_list_item cursorPointer">{{item2.name}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <div class="footer_lyout_content_company_info">
                <img :src="require('@/assets/images/general/footer_company_code.png')" alt="">
                <div class="footer_lyout_content_company_info_one">华略未来科技（重庆）有限公司版权所有2018-2021</div>
                <div class="footer_lyout_content_company_info_two">
                    <img class="gongan" :src="image_gongan" alt="">
                    <a class="cursorPointer" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002502974">渝公网安备 50019002502974号</a>
                </div>
                <div @click="clickTwo" class="footer_lyout_content_company_info_two cursorPointer">渝ICP备19012913号-1</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex'

    export default {
        components: {
        },
        computed: {
            ...mapGetters(['userInfo','menuList']),
        },
        data() {
            return {
                image_gongan:require("assets/images/general/gongan.png"),
                list:[],
            };
        },
        watch:{
            menuList:{//菜单
                handler(newV){
                    this.list=[];
                    if(!this.$utils.isArrayEmpty(this.menuList)){
                        for (let index = 0; index < this.menuList.length; index++) {
                            let element = this.menuList[index];
                            if(!this.$utils.isArrayEmpty(element.children)){
                                this.list.push(element);
                            }
                        }
                    }
                },
                immediate: true,//true刷新也会触发
            },
        },
        created(){
        },
        mounted(){
        },
        methods: {
            clickMenu(item){//点击菜单
                let origin = window.location.origin.indexOf('localhost') == -1 && window.location.origin.indexOf('192.168') == -1 ? window.location.origin : 'http://www.valuetek.com.cn'
                if(this.$utils.isNoNullAll(item.routeUrl) && this.$utils.isNoNullAll(origin)){
                    window.open(origin+item.routeUrl);
                    // this.$router.push({
                    //     path:item.routeUrl,
                    // });
                }
            },

            clickLogo(){//进入管理平台
                if(this.$utils.isNoNullAll(this.$route.path)&&this.$route.path.indexOf("/")!=-1){
                    window.open(this.$constant.allHttpUrl.clooudBaseUrl_login);
                }
            },

            clickTwo(){
                window.open("https://beian.miit.gov.cn/#/Integrated/index");
            }
        }
    }
</script>

<style lang="less" scoped>
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
@import url("./custom-footer.less");
</style>
